module.exports = __webpack_public_path__ + "static/scale-model-of-provo-utah-a41d9d41dcc19b75c605670a000f4a5f.png";